// src/components/PremiumCanceled.jsx
import { useContext, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import LeftMenu from "./menus/LeftMenu";
import HeaderBar from "./headers/HeaderBar";
import { useAuth } from "../context/AuthContext";

export default function PremiumCanceledDesktop() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("⚠️ User arrived on cancel page:", currentUser?.uid);
  }, [currentUser]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <LeftMenu />
      <Box sx={{ width: "90%", ml: 1 }}>
        <HeaderBar
          title={translate("PaymentCanceledTitle")}
          subtitle={translate("PaymentCanceledMessage")}
          showProjectSelect={false}
          userName={currentUser?.displayName}
          userRole=""
        />
        <Box
          sx={{
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <CancelOutlinedIcon
            sx={{ fontSize: 80, color: "error.main", mb: 2 }}
          />
          <Typography variant="h4" gutterBottom>
            {translate("PaymentCanceledTitle")}
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            {translate("PaymentCanceledMessage")}
          </Typography>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate("/app/premium")}
          >
            {translate("TryAgain")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
